function okOrThrow(resp) {
  if (!resp.ok) {
    throw new Error(`Server Error ${resp.status}`);
  }
}

export async function getCases() {
  const resp = await fetch("https://mirailabs-covid-19.herokuapp.com/cases/");
  okOrThrow(resp);
  const json = await resp.json();
  return json;
}
